import { z } from "zod";

// TODO: enhance validation rules as needed
export const templateFormSchema = z.object({
  name: z
    .string()
    .min(1, "Template name is required")
    .transform((val) => val.trim()),
  baseTemplateId: z.string().optional(),
  state: z.string().min(1, "State is required"),
  description: z.string().optional().or(z.literal("")),
});

export const createTemplateFormSchema = templateFormSchema.extend({
  baseTemplateId: z.string().min(1, "Base template is required"),
});

export type TemplateFormValues = z.infer<typeof templateFormSchema>;
export type CreateTemplateFormValues = z.infer<typeof createTemplateFormSchema>;
